import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';
import axios from 'axios';
import request, { apiHost, config } from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';
import { orderStatus,CONSTANT } from '../../utils/constant';
import Locked from './lockedOrder';

const CancelOrder = ({ orderData, fetchOrders, setIsDelete }) => {
  const { id, isQuoteReference, orderId } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, cancelOrderModalText },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { getProfile } = request;
  const profile = getProfile();
  const { role: { name: roleName = 'none' } = {} } = profile || {};
  const {
    KEYS: {
      ROLES: { ADMIN, SALES_REP }
    }
  } = CONSTANT;
  const isSalesRep = roleName === SALES_REP
  const isAdmin = roleName === ADMIN

  const handleCancelOrder = () => {
    // request.put(`/orders/${id}/cancel`).then(() => {
    //   setIsDelete({
    //     action: true,
    //     orderId: orderId
    //   });
    //   fetchOrders();
    // });
    let currentStatus;
    if (roleName === SALES_REP) {
      currentStatus = orderStatus.canceledBySalesRep;
    }
    else
    {
      currentStatus = orderStatus.canceled
    }
    axios
      .put(`${apiHost}/orders/${id}`, { status: currentStatus }, config())
      .then(() => {
        setIsDelete({
          action: true,
          orderId: orderId
        });
        fetchOrders();
        setIsModalOpen(false);
        window.location.reload();
      });
  };

  if (isQuoteReference) return null;

  return (
    <>
    
       <Button onClick={() => setIsModalOpen(true)}>{cancelButtonLabel}</Button>
    
    {/* {
      isSalesRep && <Locked orderData={orderData}/>
    } */}
      <Modal
        heading={confirmationDialog}
        bodyText={cancelOrderModalText}
        confirmCTAText={confirmButtonLabel}
        // cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleCancelOrder()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

CancelOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default CancelOrder;
